/**
 * React component for bottom panel.
 * Permanent box at bottom center with minimap (left), unit selection (middle), and actions (right).
 */

interface BottomPanelProps {
  minimap: React.ReactNode;
  unitSelection: React.ReactNode;
  actions: React.ReactNode;
}

export default function BottomPanel({ minimap, unitSelection, actions }: BottomPanelProps) {
  // Minimap is h-48 (12rem), padding is p-4 (1rem top and bottom)
  // Total height: 1rem (top padding) + 12rem (minimap) + 1rem (bottom padding) = 14rem
  return (
    <div
      className="w-full bg-gray-800 bg-opacity-90 rounded-t-lg p-4 flex-shrink-0"
      style={{ height: '14rem' }}
      data-bottom-panel
    >
      <div className="flex h-full w-full">
        {/* Minimap section - far left (fixed position) */}
        <div className="flex-shrink-0 w-48 pr-4">{minimap}</div>
        {/* Unit selection section - centered with fixed viewport-based width */}
        <div className="flex-1 flex justify-center">
          <div className="flex flex-col w-[30vw] min-w-[300px] max-w-[500px] px-4">
            {unitSelection}
          </div>
        </div>
        {/* Actions section - far right (fixed position) */}
        <div className="flex-shrink-0 w-80 flex flex-col pl-4">{actions}</div>
      </div>
    </div>
  );
}
